export type Capability =
  | "create-instance"
  | "terminate-instance"
  | "reboot-instance"
  | "resize-instance-volume"
  | "change-instance-type"
  | "change-spot-instance-type"
  | "stop-start-instance"
  | "machine-image"
  | "instance-userdata"
  | "billing-usage"
  | "expose-public-ports"
  | "modify-firewall";

export const terminateCapability: Capability = "terminate-instance";
export const resizeCapability: Capability = "resize-instance-volume";
export const changeInstanceTypeCapability: Capability = "change-instance-type";
export const changeSpotInstanceTypeCapability: Capability =
  "change-spot-instance-type";
export const stopStartCapability: Capability = "stop-start-instance";
export const modifyFirewallCapability: Capability = "modify-firewall";
